import type { ActionButtonProps } from '@elfsight/lib-stripe-integration';
import { ActionButton } from '@elfsight/lib-stripe-integration';
import { useLingui } from '@lingui/react/macro';
import { useWidgetDomainTexts } from '../domain-texts';

export function PayButton(
  props: Omit<ActionButtonProps, 'actionText' | 'disabledText'>
) {
  const { t } = useLingui();
  const { payButtonActionText: actionText } = useWidgetDomainTexts();

  return (
    <ActionButton
      {...props}
      actionText={actionText}
      disabledText={t`Processing Payment...`}
      maintainAppearanceWhenDisabled
    />
  );
}
